import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Modal from 'react-responsive-modal';

export class VerWhatsappCampaignsDatatable extends Component {
    constructor(props) {
        super(props)
        this.onOpenPreviewModal = this.onOpenPreviewModal.bind(this);
        this.onClosePreviewModal = this.onClosePreviewModal.bind(this);
        this.state = {
            checkedValues: [],
            myData: this.props.myData,
            openPreviewModal: false,
            selectedCampaign: null
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.myData != prevState.myData){
            this.setState({
                myData: prevProps.myData
            })
        }
    }

    selectRow = (e, i) => {
        if (!e.target.checked) {
            this.setState({
                checkedValues: this.state.checkedValues.filter((item, j) => i !== item)
            });
        } else {
            this.state.checkedValues.push(i);
            this.setState({
                checkedValues: this.state.checkedValues
            })
        }
    }

    handleRemoveRow = () => {
        const selectedValues = this.state.checkedValues;
        const updatedData = this.state.myData.filter(function (el) {
            return selectedValues.indexOf(el.id) < 0;
        });
        this.setState({
            myData: updatedData
        })
        toast.success("Successfully Deleted !")
    };

    renderEditable = (cellInfo) => {
        return (
            <div
                style={{ backgroundColor: "#fafafa" }}
                contentEditable
                suppressContentEditableWarning
                onBlur={e => {
                    const data = [...this.state.myData];
                    data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
                    this.setState({ myData: data });
                }}
                dangerouslySetInnerHTML={{
                    __html: this.state.myData[cellInfo.index][cellInfo.column.id]
                }}
            />
        );
    }

    Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    deleteCampaign(row){
        this.props.deleteCampaign(row);
    }

    onOpenPreviewModal = (campaign) => {
        this.setState({
            openPreviewModal: true,
            selectedCampaign: campaign
        });
    };

    onClosePreviewModal = () => {
        this.setState({
            openPreviewModal: false,
            selectedCampaign: null
        });
    };

    render() {
        const { pageSize, myClass, multiSelectOption, pagination } = this.props;
        const { myData } = this.state;
        var handlerPromotions = this.props.handlerPromotions;

        const columns = [];
        for (var key in myData[0]) {

            let editable = this.renderEditable;
            if (key === "Estado") {
                editable = null;
            }
            if(key === "Nombre"){
                editable = null;
            }
            if(key === "Grupo"){
                editable = null;
            }
            if(key === "Fecha Programada"){
                editable = null;
            }
            if(key === "Enviados"){
                editable = null;
            }
            if(key === "Clicks"){
                editable = null;
            }

            if(key != "id" && key != "data")
            {
                columns.push(
                    {
                        Header: <b>{this.Capitalize(key.toString())}</b>,
                        accessor: key,
                        Cell: editable,
                        style: {
                            textAlign: 'center'
                        }
                    });
            }
        }

        if (multiSelectOption == true) {
            columns.push(
                {
                    Header: <button className="btn btn-danger btn-sm btn-delete mb-0 b-r-4"
                        onClick={
                            (e) => {
                                if (window.confirm('Are you sure you wish to delete this item?'))
                                    this.handleRemoveRow()
                            }}>Delete</button>,
                    id: 'delete',
                    accessor: str => "delete",
                    sortable: false,
                    style: {
                        textAlign: 'center'
                    },
                    Cell: (row) => (
                        <div>
                            <span >
                                <input type="checkbox" name={row.original.id} defaultChecked={this.state.checkedValues.includes(row.original.id)}
                                    onChange={e => this.selectRow(e, row.original.id)} />
                            </span>
                        </div>
                    ),
                    accessor: key,
                    style: {
                        textAlign: 'center'
                    }
                }
            )
        } else {
            columns.push(
                {
                    Header: <b>Acción</b>,
                    id: 'delete',
                    accessor: str => "delete",
                    Cell: (row) => (
                        <div>
                            <Link to={`#`} title="Ver campaña" onClick={() => this.onOpenPreviewModal(row.original.data)}>
                                <i className="fa fa-eye" style={{ width: 35, fontSize: 20, padding: 11, color:'rgb(23, 162, 184)' }}></i>
                            </Link>
                            <Link to={`${process.env.PUBLIC_URL}/edit-whatsapp-campaign/${row.original.id}`} title="Editar">
                                <i className="fa fa-pencil" style={{ width: 35, fontSize: 20, padding: 11, color:'rgb(40, 167, 69)' }}></i>
                            </Link>
                            <Link to={`#`} title="Eliminar" onClick={() => {
                                Swal.fire({
                                    title: 'Confirmar',
                                    text: '¿Desea eliminar la campaña "'+ row.original.Nombre +'"?',
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'Confirmar',
                                    cancelButtonText: 'Cancelar'
                                 }).then((result) => {
                                    if(result.value){
                                        let data = myData;
                                        data.splice(row.index, 1);
                                        this.setState({ myData: data });
                                        this.deleteCampaign(row)
                                   }
                                 })
                            }}>
                                <i className="fa fa-trash" style={{ width: 35, fontSize: 20, padding: 11, color: '#e4566e' }}></i>
                            </Link>
                        </div>
                    ),
                    style: {
                        textAlign: 'center'
                    },
                    sortable: false
                }
            )
        }

        const { selectedCampaign } = this.state;

        return (
            <Fragment>
                <ReactTable
                    data={myData}
                    columns={columns}
                    defaultPageSize={pageSize}
                    className={myClass}
                    showPagination={pagination}
                />

                <Modal open={this.state.openPreviewModal} onClose={this.onClosePreviewModal} center>
                    <div className="modal-header">
                        <h5 className="modal-title">Vista Previa de Campaña</h5>
                    </div>
                    <div className="modal-body" style={{ minWidth: '500px', maxWidth: '700px' }}>
                        {selectedCampaign && (
                            <div>
                                <div className="card mb-3">
                                    <div className="card-header bg-primary text-white">
                                        <h6 className="mb-0">{selectedCampaign.campaign_name}</h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-12">
                                                <strong>Estado:</strong>
                                                <span className={`badge ml-2 ${
                                                    selectedCampaign.campaign_status === 'ENVIADA' ? 'badge-success' :
                                                    selectedCampaign.campaign_status === 'PROGRAMADA' ? 'badge-warning' :
                                                    selectedCampaign.campaign_status === 'CANCELADA' ? 'badge-danger' :
                                                    'badge-secondary'
                                                }`}>
                                                    {selectedCampaign.campaign_status}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className="col-12">
                                                <strong>Grupo de clientes:</strong>
                                                <p className="mb-0">{selectedCampaign.Cluster ? selectedCampaign.Cluster.cluster_name : 'Sin grupo'}</p>
                                            </div>
                                        </div>

                                        {selectedCampaign.Collection && (
                                            <div className="row mb-2">
                                                <div className="col-12">
                                                    <strong>Colección de productos:</strong>
                                                    <p className="mb-0">{selectedCampaign.Collection.collection_name}</p>
                                                </div>
                                            </div>
                                        )}

                                        {selectedCampaign.discount_percentage && (
                                            <div className="row mb-2">
                                                <div className="col-12">
                                                    <strong>Descuento:</strong>
                                                    <span className="badge badge-success ml-2">{selectedCampaign.discount_percentage}% OFF</span>
                                                </div>
                                            </div>
                                        )}

                                        <div className="row mb-2">
                                            <div className="col-12">
                                                <strong>Enviados:</strong> {selectedCampaign.sent_count || 0}
                                            </div>
                                        </div>

                                        {selectedCampaign.scheduled_date && (
                                            <div className="row mb-2">
                                                <div className="col-12">
                                                    <strong>Fecha programada:</strong>
                                                    <p className="mb-0">{new Date(selectedCampaign.scheduled_date).toLocaleString('es-ES')}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="card">
                                    <div className="card-header bg-success text-white">
                                        <h6 className="mb-0">
                                            <i className="fa fa-whatsapp mr-2"></i>
                                            Mensaje de WhatsApp
                                        </h6>
                                    </div>
                                    <div className="card-body" style={{ backgroundColor: '#e5ddd5', padding: '20px' }}>
                                        <div style={{
                                            backgroundColor: 'white',
                                            padding: '15px',
                                            borderRadius: '8px',
                                            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                            position: 'relative',
                                            maxWidth: '400px'
                                        }}>
                                            <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                                {selectedCampaign.whatsapp_message}
                                            </div>
                                            <div style={{
                                                fontSize: '11px',
                                                color: '#667781',
                                                textAlign: 'right',
                                                marginTop: '8px'
                                            }}>
                                                {new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {selectedCampaign.id_banner && (
                                    <div className="card mt-3">
                                        <div className="card-header">
                                            <h6 className="mb-0">Banner asociado</h6>
                                        </div>
                                        <div className="card-body">
                                            <p className="text-muted">ID Banner: {selectedCampaign.id_banner}</p>
                                        </div>
                                    </div>
                                )}

                                <div className="alert alert-info mt-3" role="alert">
                                    <strong>UID de la campaña:</strong> {selectedCampaign.campaign_uid}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={this.onClosePreviewModal}
                        >
                            Cerrar
                        </button>
                    </div>
                </Modal>

                <ToastContainer />
            </Fragment>
        )
    }
}

export default VerWhatsappCampaignsDatatable
